/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Transcript_Export_Field_EndInputs */



/**
* | output |
* | --- |
* | "End Time" |
*
* @param {Transcript_Export_Field_EndInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const transcript_export_field_end = /** @type {((inputs?: Transcript_Export_Field_EndInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Transcript_Export_Field_EndInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("End Time")
	if (locale === "de") return /** @type {LocalizedString} */ ("End Time")
	if (locale === "it") return /** @type {LocalizedString} */ ("End Time")
	if (locale === "ru") return /** @type {LocalizedString} */ ("End Time")
	if (locale === "es") return /** @type {LocalizedString} */ ("End Time")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("End Time")
	if (locale === "ja") return /** @type {LocalizedString} */ ("End Time")
	if (locale === "hi") return /** @type {LocalizedString} */ ("End Time")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("End Time")
	return /** @type {LocalizedString} */ ("End Time")
});